import * as React from "react";

function SvgCheckmarkInCircle(props) {
  return <svg width={24} height={24} viewBox="0 0 24 24" {...props}><circle cx={12} cy={12} r={12} fill="currentColor" /><path fill="#fff" d="M16.3 7l-.8.8-5.4 5.9L8.4 12l-.8-.8L6 12.9l.8.8 2.5 2.5.8.8.8-.9 6.3-6.7.8-.8z" /></svg>;
}

export default "//cdn.scentbird.com/assets/frontbird-site/images/checkmark-in-circle_6293bc.svg";
export { SvgCheckmarkInCircle as ReactComponent };